<template>
    <div>
        <selections
            :meeting="meeting"
            :selections="selectedRunners"
            @changeSelection="changeSelection"
            @betPlaced="updateBetRunners"
            @hasBet="hasBet"
        />
    </div>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import Selections from "@/Global/Play/Partials/Selections";

export default {
    props: {
        meeting: {
            type: Object,
            default: {},
        },
    },

    emits: ["changeSelection", "hasBet"],

    setup(props, { emit }) {
        const store = useStore();

        const betRunners = ref({});

        const selectedRunners = computed(() => {
            if (Object.keys(betRunners.value).length) {
                return betRunners.value;
            }

            let selectedRunners = [];

            Object.keys(store.state.play.selectedRunners).forEach((key) => {
                if (
                    store.state.play.selectedRunners[key].race.meeting_id ==
                    props.meeting.id
                ) {
                    selectedRunners.push(store.state.play.selectedRunners[key]);
                }
            });

            return selectedRunners;
        });

        const log = (logger) => {
            return console.log(logger);
        };

        const updateBetRunners = (runners) => {
            betRunners.value = runners;
        };

        const changeSelection = (selection) => {
            emit("changeSelection", selection);
        };

        const hasBet = () => {
            emit("hasBet");
        };

        return {
            store,
            selectedRunners,
            changeSelection,
            updateBetRunners,
            hasBet,
        };
    },
};
</script>
